export default "__VITE_ASSET__BoID31yJ__"